import {stage} from '../../../../config/stage';

// FNP-582: Stripe PUBLISHABLE key (pk_) per stage — NOT secret (ships to the
// browser). Each stage points at its own Stripe sandbox; prod uses the
// flexi-marketplace-prod-sandbox pk_ (test mode pre-go-live, swapped to pk_live_
// at go-live alongside the API-side sk_live_ swap). dev/ide share the
// marketplace-dev sandbox key.
const stripeConfig = {
    prod: {
        publishableKey: 'pk_test_51Tl1QiHk8dx6ZaXw97PUagRPCX5dSpLwaWStodb4NuOu9VctnR213hEDf6lEhHUKvdc7bgB7RGuWsIkkRYkuQYx100rHlZwFTa',
    },
    test: {
        publishableKey: 'pk_test_51PCp3LHGR54UWb7WPZ7fRn5MvZDwJ8g7ERrfXro0upfMuTqDjObSl7fJBD3jVWtPl9K1DLYcQOOO6bDIoLb79vRK00wQMUxkeJ',
    },
    dev: {
        publishableKey: 'pk_test_51PCp2pHFN7HgbQ5GfapDnzS4pYfysrTjegKneBwkpvmzdeN9K5wTmTVRPCPdfqV3Jsb3ZETrm1daP4zGasMTgR370006YIUiXr',
    },
    ide: {
        publishableKey: 'pk_test_51PCp2pHFN7HgbQ5GfapDnzS4pYfysrTjegKneBwkpvmzdeN9K5wTmTVRPCPdfqV3Jsb3ZETrm1daP4zGasMTgR370006YIUiXr',
    },
};


export const stripePublishableKey = stripeConfig[stage].publishableKey;

export const stripeOptions = {
    mode: 'payment' as const,
    currency: 'usd',
    appearance: {
        theme: 'stripe' as const,
    },
};


